window.imagesLoaded = require('./lib/imagesloaded.pkgd.min.js');
import './lib/freezeframe.js';


var initializeFreezeframe = function(gifs) {
    var cover = '<div class="freezeframe-cover"><i class="fa fa-play-circle freezeframe-cover-button"></i></div>';
    var enlargeButton = '<div class="freezeframe-enlarge"><i class="fa fa-expand freezeframe-enlarge-button"></i></div>';

    (gifs || jQuery('.freezeframe'))
        .freezeframe({
            non_touch_device_trigger_event: 'click',
            animation_play_duration: Infinity,
        })
        .each(function() {
            var $this = jQuery(this);
            var $cover = jQuery(cover).on('click', function() {
                $this.click();
            });
            var $enlargeButton = jQuery(enlargeButton).magnificPopup({
                items: {
                    src: $this.attr('src'),
                },
                image: {
                    cursor: null,
                },
                type: 'image',
            });
            $this
                .parent()
                .append($cover)
                .append($enlargeButton);
        });
};

// Freezeframe has no .destroy method, so we need to do it ourselves
var destroyFreezeframe = function() {
    jQuery('.ff-container').each(function() {
        var $this = jQuery(this);
        var $img = $this.find('img.ff-image');
        if ($img.length > 0) {
            var $parent = $this.parent();
            $img.removeClass('ff-setup ff-image ff-image-ready').detach();
            $this.remove();
            $parent.append($img);
        }
    });
};

jQuery(function() {
    // Initialize gifs with freezeframe
    var gifs = jQuery('.freezeframe');
    if (gifs.length) {
        initializeFreezeframe(gifs);
    }

    // Initialize twentytwenty slider images
    var containers = jQuery('.twentytwenty-container');
    if (containers.length) {
        initializeTwentyTwenty(containers);
    }
});

var resizeTimer;
jQuery(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        if (jQuery('.freezeframe').length) {
            destroyFreezeframe();
            initializeFreezeframe();
        }
    }, 250);
});
